exports.f = Object.getOwnPropertySymbols;



//////////////////
// WEBPACK FOOTER
// ./packages/layout/node_modules/core-js/library/modules/_object-gops.js
// module id = 212
// module chunks = 0